import script from "./layout.vue?vue&type=script&setup=true&lang=js"
export * from "./layout.vue?vue&type=script&setup=true&lang=js"

import "./layout.vue?vue&type=style&index=0&id=8643affc&lang=scss"

const __exports__ = script;

export default __exports__